import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
// @material-ui/icons
import Clear from '@material-ui/icons/Clear'
import Check from '@material-ui/icons/Check'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import deLocale from 'date-fns/locale/de'

// core components
import styles from 'assets/jss/dorm-app/components/customInputStyle.js'
import { format } from 'date-fns'

const useStyles = makeStyles(styles)

class DeLocalizedUtils extends DateFnsUtils {
  getCalendarHeaderText(date) {
    return format(date, 'LLLL', { locale: this.locale })
  }

  getDatePickerHeaderText(date) {
    return format(date, 'dd MMMM', { locale: this.locale })
  }
}

export default function CustomInput(props) {
  const classes = useStyles()
  const { formControlProps, labelText, error, success, inputProps } = props

  const labelClasses = classNames({
    [' ' + classes.dateLabel]: success && !error,
  })
  return (
    <FormControl {...formControlProps} className={formControlProps.className + ' ' + classes.formControlWithoutMargin}>
      {labelText !== undefined ? (
        <InputLabel className={classes.labelRoot + labelClasses}>{labelText}</InputLabel>
      ) : null}
      <div className={classes.marginTop40}>
        <MuiPickersUtilsProvider utils={DeLocalizedUtils} locale={deLocale}>
          <KeyboardDatePicker
            {...inputProps}
            style={{ width: '100%' }}
            clearable
            placeholder="Datum eingeben"
            format={'dd.MM.yyyy'}
          />
        </MuiPickersUtilsProvider>
        {error ? (
          <Clear className={classes.feedback + ' ' + classes.labelRootError}/>
        ) : success ? (
          <Check className={classes.feedback + ' ' + classes.labelRootSuccess}/>
        ) : null}
      </div>
    </FormControl>
  )
}

CustomInput.propTypes = {
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  error: PropTypes.bool,
  success: PropTypes.bool,
}
